import React from "react";
import {
  Link
} from "react-router-dom";
import ModelViewer from "../../core/ModelViewer/ModelViewer";

import styles from "./Avatar.module.css";

import {BASE} from '../../Models';

export default function Avatar() {

  const viewer: any = React.useRef();

  return (
    <div className={styles.Home}>
      <p style={{margin: 0, paddingLeft: 20, marginTop:8}}>Wähle einen Modus aus: </p>
      <div className={styles.Content}>
        <ul className={styles.AvatarList}>
          <li>
            <Link to="/avatar/0">
              <div className={styles.Avatar}>
                <ModelViewer noControls={true} noMove={true} autoplay={true} ref={viewer} src={`${BASE}/avatar/Joker_gruss.glb`} />
              </div>
              <span>Gruss</span>
            </Link>
          </li>
          <li>
            <Link to="/avatar/1">
              <div className={styles.Avatar}>
                <ModelViewer noControls={true} noMove={true} autoplay={true} ref={viewer} src={`${BASE}/avatar/Joker_FotoPose1.glb`} />
              </div>
              <span>Foto-Pose 1</span>
            </Link>
          </li>
          <li>
            <Link to="/avatar/2">
              <div className={styles.Avatar}>
                <ModelViewer noControls={true} noMove={true} autoplay={true} ref={viewer} src={`${BASE}/avatar/Joker_FotoPose2.glb`} />
              </div>
              <span>Foto-Pose 2</span>
            </Link>
          </li>
          <li>
            <Link to="/avatar/3">
              <div className={styles.Avatar}>
                <ModelViewer noControls={true} noMove={true} autoplay={true} ref={viewer} src={`${BASE}/avatar/Joker_Hut.glb`} />
              </div>
              <span>Hut</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}